import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#e11ea5',
        secondary: '#a2a2a2',
        accent: '#6f6f6f',
      },
    },
  },
});
